// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('sales.salescomparison', {
        url: '/salescomparison',
        views: {
            'wideColumnView@sales': {
                templateUrl: 'main/sales/salescomparison/salescomparison.tpl.html',
                controller: 'SalesComparisonController as vm'
            }
        }
    });
}

// @ngInject
function SalesComparisonController() {
    var vm = this;
}

angular
    .module('sales.salescomparison', [])
    .config(stateConfig)
    .controller('SalesComparisonController', SalesComparisonController);
